import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { IApiResponse } from "../../../utils/types/api-response";
import {
    IAddPaymentCardPayload,
    IChargePaymentCardPayload,
    IPaymentCard,
} from "../types/billing.types";
import {
    addPaymentCard,
    chargePaymentCard,
    deletePaymentCards,
} from "../services/billing.services";

export function useAddPaymentCard(consentId?: string) {
    return useMutation<
        IApiResponse<IPaymentCard>,
        AxiosError<IApiResponse<IPaymentCard>>,
        IAddPaymentCardPayload
    >({
        mutationKey: ["add-payment-card"],
        mutationFn: (data: IAddPaymentCardPayload) =>
            addPaymentCard(data, consentId),
    });
}

export function useChargePaymentCard() {
    return useMutation<
        IApiResponse<IPaymentCard>,
        AxiosError<IApiResponse<IPaymentCard>>,
        IChargePaymentCardPayload
    >({
        mutationKey: ["charge-payment-card"],
        mutationFn: (data: IChargePaymentCardPayload) =>
            chargePaymentCard(data),
    });
}

export function useDeletePaymentCards() {
    return useMutation<
        IApiResponse<{
            deleted_card_ids: string[];
            undeleted_card_ids: Array<{ card_id: string; reason: string }>;
        }>,
        AxiosError<
            IApiResponse<{
                deleted_card_ids: string[];
                undeleted_card_ids: Array<{ card_id: string; reason: string }>;
            }>
        >,
        string[]
    >({
        mutationKey: ["delete-payment-cards"],
        mutationFn: (cardIds: string[]) => deletePaymentCards(cardIds),
    });
}
